<template>
	<div class="table-box" ref="scroll" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" 
				@click="sortClick(0)">
					ID
					<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': rableTitle[0].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': rableTitle[0].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" 
				@click="sortClick(1)">
					作品名称
				</div>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="(item.type !== 'put_book_id' && item.type !== 'book_name' && item.type !== 'cz')" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				
					<div  class="table-td-cell"
					:style="{'width':rableTitle[0].width + 'px'}">
						{{item.put_book_id}}
					</div>
					<div  class="table-td-cell"
					:style="{'width':rableTitle[1].width + 'px'}">
						{{item.book_name}}
					</div>
				
			</div>
			<!-- 渠道 -->
			<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
				{{item.book_channel}}
			</div>
			<!-- 频道 -->
			<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
				{{item.book_type | bookTypeFilters}}
			</div>
			<!-- 分类 -->
			<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
				{{item.category}}
			</div>
			<!-- 首日ROI目标(%) -->
			<div class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}" >
				{{item.return_require}}
			</div>
			<!-- 操作 -->
			<div v-if="false" @click="editTable(index)" class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
			<!-- 投放公众号个数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}">
				{{item.put_gzh_count}}
			</div>
			<!-- 投放天数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{item.put_days}}
			</div>
			<!-- 消耗(元) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{item.net_put_money | tableToFixed}}
			</div>
			<!-- 回款(元) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{item.net_charge_money}}
			</div>
			<!-- 首日回款(元) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{item.first_day_net_charge_money}}
			</div>
			<!-- 支付粉价(元) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{item.fan_price | tableToFixed}}
			</div>
			<!-- ROI(%) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13].width + 'px'}">
				{{item.roi*100 | tableToFixed}}%
			</div>
			<!-- 首日ROI(%) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[14].width + 'px'}">
				{{item.first_day_roi*100 | tableToFixed}}%
			</div>
			<!-- 利润(元) -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[15].width + 'px'}">
				{{item.money | tableToFixed}}
			</div>
			<!-- 充值1次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[16].width + 'px'}">
				{{item.pay1}}
				<div style="color: #3085d6;">{{item.pay1_rate}}</div>
			</div>
			<!-- 充值2次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17].width + 'px'}">
				{{item.pay2}}
				<div style="color: #3085d6;">{{item.pay2_rate}}</div>
			</div>
			<!-- 充值3次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[18].width + 'px'}">
				{{item.pay3}}
				<div style="color: #3085d6;">{{item.pay3_rate}}</div>
			</div>
			<!-- 充值4次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[19].width + 'px'}">
				{{item.pay4}}
				<div style="color: #3085d6;">{{item.pay4_rate}}</div>
			</div>
			<!-- 充值5次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20].width + 'px'}">
				{{item.pay5}}
				<div style="color: #3085d6;">{{item.pay5_rate}}</div>
			</div>
			<!-- 充值6次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[21].width + 'px'}">
				{{item.pay6}}
				<div style="color: #3085d6;">{{item.pay6_rate}}</div>
			</div>
			<!-- 充值7次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22].width + 'px'}">
				{{item.pay7}}
				<div style="color: #3085d6;">{{item.pay7_rate}}</div>
			</div>
			<!-- 充值8次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23].width + 'px'}">
				{{item.pay8}}
				<div style="color: #3085d6;">{{item.pay8_rate}}</div>
			</div>
			<!-- 充值9次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[24].width + 'px'}">
				{{item.pay9}}
				<div style="color: #3085d6;">{{item.pay9_rate}}</div>
			</div>
			<!-- 充值10次人数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25].width + 'px'}">
				{{item.pay10}}
				<div style="color: #3085d6;">{{item.pay10_rate}}</div>
			</div>
			
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'TableBook',
	props: ['rableTitle','tableShowData','tableTotalData','table_scroll_width','date_type_control'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		editTable(index){
			this.$emit('edit-td-click', index)
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){
			// console.log("书籍-过滤器",value)
			let v = ""
			if(Number(value)){
				v = Number(value).toFixed(2)
				
			}
			else {
				v = 0
			}
			return v
		}
	}
}
</script>

<style scoped>
.table-box {
	position: relative;
	width: 100%;
	overflow-x: visible;
}

.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}



</style>